import type { EventqShortcutBinding } from './shortcut.models';

function normalizeKey(key: string): string {
  if (key === ' ' || key === 'Spacebar' || key === 'Space') {
    return 'Space';
  }
  return key;
}

/** Returns true when the keyboard event matches the binding chord. */
export function matchesBinding(event: KeyboardEvent, binding: EventqShortcutBinding): boolean {
  if (normalizeKey(event.key) !== normalizeKey(binding.key)) {
    return false;
  }
  if (!!event.ctrlKey !== !!binding.ctrl) {
    return false;
  }
  if (!!event.shiftKey !== !!binding.shift) {
    return false;
  }
  if (!!event.altKey !== !!binding.alt) {
    return false;
  }
  if (!!event.metaKey !== !!binding.meta) {
    return false;
  }
  return true;
}
